import React, { useState, useContext } from "react";
import styled from "styled-components";
import { Icon, Spacer, Theme, Title, Button, ThirdTitle } from "@dspworkplace/ui";
import TabPanel from "./tabPanel";
import DayPicker from "../../../components/Calendar/dayNew";
import { WeekProvider } from "./store";
import Store from "./store";
import moment from "moment";
import { useAuth, getCompanyId } from "../../../Auth";
import Day from "./day";
import ViewSelector from "../Common/ViewSelector";
import ExportButton from "../Common/ExportButton";
import { Action } from "../Common/UI";
import PublishPopUp from "../Common/PublishPopUp";
import { useSelectedStation } from "../../../components/StationSelector";
import { FilterWeekDate } from "../../../hooks/useGlobalData";
import { showDriverSelection } from "../../SchedulerLoadOut/driverSelection";
import { confirm } from "../../../components/Confirm";
import useSchedulerApi from "../Common/api";
import { TIME_OFF_UNAVAILABLE_SUSPENDED_CATEGORIES } from "../Common/shiftCategories";
import { alert } from "../../../components/Alert";
import { showToast } from "../../../Utilities";

const Body = styled.div`
    box-sizing: border-box;
    max-height: 100vh;
    padding: 20px 20px 0 20px;

    @media (max-width: 1201px) {
        .title {
            font-size: 32px;
        }
    }
`;

const ActionBox = styled.div`
    display: flex;
    align-items: center;
`;

const ExportActions = styled.div`
    margin-left: auto;
`;

const Container = styled.div`
    box-sizing: border-box;
    display: flex;
`;

const PublishChangesStatus = styled.div`
    padding: 2px 8px;
    vertical-align: middle;
    position: relative;
    z-index: 1;
    display: inline-flex;
    font-family: ${Theme.font.body}
`;

const App = () => {
    let [newDate, setNewDate] = FilterWeekDate();
    //let [newDate, setNewDate] = useLocalStorage("schedulerDate", new Date());
    const fakeRefresh = useState(0);
    const fakeRefreshData = useState(0);

    let selectedDate = moment(newDate).format("YYYY-MM-DD");
    const { api } = useAuth();

    const [selectedStation] = useSelectedStation();
    let week = moment(selectedDate).isoWeek();
    if (moment(selectedDate).day() === 0) {
        week = moment(selectedDate).add(1, "days").isoWeek();
    }

    let year = parseInt(moment(selectedDate).startOf("week").format("YYYY"));
    if (
        moment(selectedDate).startOf("week").format("YYYY") != moment(selectedDate).endOf("week").format("YYYY") &&
        week == 1 &&
        year == moment(selectedDate).startOf("week").format("YYYY")
    ) {
        year = parseInt(moment(selectedDate).endOf("week").format("YYYY"));
    }

    return (
        <WeekProvider>
            <Body>
                <ActionBox>
                    <PublishPopUp
                        date={newDate}
                        week={week}
                        year={year}
                        view={"day"}
                        fakeRefresh={fakeRefresh}
                        fakeRefreshData={fakeRefreshData}
                    />
                    <Spacer inline left={5}>
                        <Title className={"title"}>{moment(newDate).format("MMMM D, YYYY")}</Title>
                    </Spacer>
                    <ExportActions>
                        <PublishShiftCount></PublishShiftCount>
                        <Spacer
                            inline={true}
                            style={{ position: "relative", verticalAlign: "top", zIndex: 99 }}
                            right={3}
                        >
                            <Action
                                onClick={() => {
                                    setNewDate(moment(newDate).subtract(1, "day"));
                                }}
                            >
                                <Icon.ArrowLeft
                                    size="12px"
                                    color={Theme.colors.info.border}
                                    style={{ verticalAlign: "text-top" }}
                                />
                            </Action>
                            <DayPicker
                                id="day-view-calendar"
                                onChange={(date) => {
                                    if (date.utc) {
                                        const utc = moment.utc(date.utc);
                                        if (utc.isValid() && selectedDate !== utc.format("YYYY-MM-DD")) {
                                            setNewDate(date.utc);
                                        }
                                    }
                                }}
                                defaultValue={selectedDate}
                                size={"small"}
                            />
                            <Action
                                onClick={() => {
                                    setNewDate(moment(newDate).add(1, "day"));
                                }}
                            >
                                <Icon.ArrowRight
                                    size="12px"
                                    color={Theme.colors.info.border}
                                    style={{ verticalAlign: "text-top" }}
                                />
                            </Action>
                        </Spacer>
                        <ExportButton
                            params={{
                                actions: {
                                    response: {
                                        DriverRoute: {
                                            custom: {
                                                functionName: "getDriverShiftByDateForDayViewForExport",
                                                get: "file",
                                                criteria: {
                                                    date: selectedDate,
                                                    timezoneOffset: new Date().getTimezoneOffset(),
                                                    station: selectedStation,
                                                    week: week,
                                                    year: year,
                                                },
                                            },
                                        },
                                    },
                                },
                            }}
                        />
                        <Spacer right={3} inline />
                        <ViewSelector />
                        {/*<ExportActionsBtn onClick={() => window.print()}><Icon.Printer size='20px' color={Theme.colors.secondary} /></ExportActionsBtn> */}
                    </ExportActions>
                </ActionBox>
                <Spacer top={5} />

                <Container>
                    <TabPanel>
                        <Spacer top={5}>
                            <AddDriverButton fakeRefresh={fakeRefresh} selectedDate={selectedDate} />
                        </Spacer>
                    </TabPanel>
                    <Day
                        WeekTable
                        weekDate={selectedDate}
                        fakeRefresh={fakeRefresh}
                        fakeRefreshData={fakeRefreshData}
                    />
                </Container>
            </Body>
        </WeekProvider>
    );
};

const PublishShiftCount = () => {
    const [state, dispatch] = useContext(Store);

    return ((state.disabledDriverRouteTemp && state.disabledDriverRouteTemp.length > 0)?
        <PublishChangesStatus>
            <ThirdTitle>{ ' Publishing ('+state.disabledDriverRouteTemp.length+' Remains) ...'}</ThirdTitle>
        </PublishChangesStatus> :
        <></>
    );
};

const AddDriverButton = ({ fakeRefresh, selectedDate }) => {
    const [updateScheduler, setUpdatedScheduler] = fakeRefresh;
    const [state, dispatch] = useContext(Store);
    const { api } = useAuth();
    let [newDate, setNewDate] = FilterWeekDate();
    const [selectedStation] = useSelectedStation();
    const schedulerApi = useSchedulerApi();

    const handleAddDriver = async () => {
        showDriverSelection({}, api, {
            type: "SCHEDULER_ADD_ROUTE",
            station: selectedStation,
            stationTimezone: JSON.parse(localStorage.getItem("station")).timezone,
            date: newDate,
        }).then(async (data) => {
            if (!data) return;

            data.driver = data.driver;
            data.date = newDate;
            let day7ConsecutiveShift = null;
            const is_TimeOff_UnAvailable_Suspended_ShiftCategory = TIME_OFF_UNAVAILABLE_SUSPENDED_CATEGORIES.includes(data?.extra?.category);
            if (is_TimeOff_UnAvailable_Suspended_ShiftCategory !== true) {
                const params1 = {
                    actions: {
                        response: {
                            DriverRoute: {
                                custom: {
                                    functionName: "checkSequenceDriverRoute",
                                    get: "checkSequenceDriverRoute",
                                    excludes: [],
                                    criteria: {
                                        routeId: "",
                                        driverId: data.driver,
                                        newDate: selectedDate,
                                    },
                                },
                            },
                        },
                    },
                };
                const response = await api.post("/api/lazy/manage/data", params1);
                if (response.data.data.checkSequenceDriverRoute.status) {
                    const wc = await confirm(response.data.data.checkSequenceDriverRoute.message.web);
                    if (!wc) return undefined;
                    day7ConsecutiveShift = response.data.data.checkSequenceDriverRoute.message.bot;
                }
            }

            const params2 = {
                actions: {
                    response: {
                        DriverRoute: {
                            custom: {
                                functionName: "check60WorkHoursWeb",
                                get: "check60WorkHoursWeb",
                                excludes: [],
                                criteria: {
                                    company: getCompanyId(),
                                    station:selectedStation,
                                    drivers: data.driver.map((d) => {return { 'selectedDate' : [moment(selectedDate).format("YYYY-MM-DD")], 'driverId' : d, 'routeId' : "" }}),
                                    newDate: moment(selectedDate).format("YYYY-MM-DD"),
                                    startTime: data.startTime,
                                    endTime: data.endTime,
                                    type: "multiple",
                                    shiftId: data.shift
                                },
                            },
                        },
                    },
                },
            };
            const responseDriver60Hours = await api.post("/api/lazy/manage/data", params2);
            if (responseDriver60Hours.data.data.check60WorkHoursWeb != "") {
                const confirmation = await confirm(responseDriver60Hours.data.data.check60WorkHoursWeb);
                if (!confirmation) {
                    return true;
                }
            }
            

            const params = {
                actions: {
                    response: {
                        DriverRoute: {
                            custom: {
                                functionName: "schedulerLoadOutAddDriverSave",
                                get: "result",
                                excludes: [
                                    "skill",
                                    "vehicle",
                                    "device",
                                    "driver",
                                    "station",
                                    "shiftType",
                                    "schedule",
                                    "vehicleDriverRecord",
                                    "status",
                                    "tempDriverRoutes",
                                    "kickoffLog",
                                    "returnToStation",
                                    "oldDriver",
                                    "oldDriverRoute",
                                    "driverRoutes",
                                    "oldTempDriverRoutes",
                                ],
                                criteria: {
                                    shift: data.shift,
                                    driverId: data.driver,
                                    invoiceType: data.invoiceType,
                                    routeStatus: data.routeStatus,
                                    backupStatus: data.backupStatus,
                                    onCall: data.onCall,
                                    startTime: data.startTime,
                                    endTime: data.endTime,
                                    timezoneOffset: new Date().getTimezoneOffset(),
                                    date: selectedDate,
                                    station: selectedStation,
                                    inactiveCurrent: data.inactiveCurrent,
                                    view: 'day',
                                },
                            },
                        },
                    },
                },
            };
            try {
                const response = await api.post("/api/lazy/manage/data", params);
                if (data.station == selectedStation) {
                    if (data.inactiveCurrent == true) {
                        setUpdatedScheduler(updateScheduler + 1);
                    } else {
                        if(response.data.data.result.shiftData != null) {
                            dispatch({
                                type: "MOVE",
                                payload: {
                                    to: { type: "DRIVERS_SHIFT", driverId: data.driver },
                                    from: { type: 'none' },
                                    shift: response.data.data.result.shiftData
                                },
                            });
                            dispatch({
                                type: "SET_PUBLISH_COUNT",
                                ids: [response.data.data.result.shiftData.id],
                                station: response.data.data.stationId,
                                api: false
                            });
                        }
                        let responseHoursWorks = await schedulerApi.updateDriverScheduleHourWorks(data.date, state.selectedStation);
                        if (responseHoursWorks) {
                            dispatch({
                                type: "UPDATE_DRIVER_WORK_HOURS",
                                payload: {
                                    type: "driversShifts",
                                    driverHoursWork: responseHoursWorks.data.data.result,
                                },
                            });
                        }
                    }
                } else {
                    setUpdatedScheduler(updateScheduler + 1);
                }
                if (day7ConsecutiveShift != null && !TIME_OFF_UNAVAILABLE_SUSPENDED_CATEGORIES.includes(data?.extra?.category)) {
                    const params1 = {
                        actions: {
                            response: {
                                DriverRoute: {
                                    custom: {
                                        functionName: "createEventForConsicutiveShift",
                                        get: "createEventForConsicutiveShift",
                                        excludes: [],
                                        criteria: {
                                            driverId: data.driver,
                                            message: day7ConsecutiveShift,
                                        },
                                    },
                                },
                            },
                        },
                    };
                    await api.post("/api/lazy/manage/data", params1);
                }
                if (response.data.data.result.driverNameStr != null) {
                    const dialogMsg = `The new shift time overlaps with an existing shift. You cannot add this driver shift for ${response.data.data.result.driverNameStr}`;
                    alert({
                        title: "Overlap Shift Time",
                        text: dialogMsg,
                        btnText: "Cancel",
                    });
                }
                return true;
            } catch (error) {
                if (error.response.status === 400) {
                    showToast({
                        type: "Error",
                        title: "We are sorry 😥.",
                        content: `Something went wrong. Please try again`,
                    });
                    return;
                }
                if (error.response.status == "401") {
                    window.location = "/logout";
                }
            }
        });
    };

    return (
        <Button
            size="small"
            onClick={() => {
                handleAddDriver();
            }}
            type={"default"}
        >
            Add Driver
        </Button>
    );
};

export default App;
